import { FC } from 'react';

import { Box, CircularProgress, SvgIcon } from '@mui/material';
import { useSettingsStore } from 'app/store';

interface IProps {
  isSelect?: boolean;
  top?: string;
}
const CircularProgressCenter: FC<IProps> = ({ isSelect, top }) => {
  const { darkTheme } = useSettingsStore();

  return (
    <Box
      sx={{
        width: isSelect ? 10 : 74,
        height: isSelect ? 10 : 74,
        position: 'absolute',
        top: top ?? '50%',
        left: '50%',
        borderRadius: '50%',
        display: 'inline-block',
        animation: 'rotation 1s linear infinite',
        background: darkTheme
          ? 'conic-gradient(from 180deg at 50% 50%, rgba(21, 21, 21, 1), rgb(65 86 112), rgba(75, 150, 231, 1))'
          : 'conic-gradient(from 180deg at 50% 50%, rgba(226, 234, 247, 1), rgb(132 164 217), rgba(24, 90, 194, 1))',
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: isSelect ? 2 : 8,
          left: isSelect ? 2 : 8,
          right: isSelect ? 2 : 8,
          bottom: isSelect ? 2 : 8,
          background: 'var(--mui-palette-background-default)',
          borderRadius: '50%'
        },
        '@keyframes rotation': {
          '0%': { transform: 'rotate(0deg)' },
          '100%': { transform: 'rotate(360deg)' }
        }
      }}
    />
  );
};

export default CircularProgressCenter;
